import ProfileIcon from './ProfileIcon';

export default ProfileIcon;
